// extracted by mini-css-extract-plugin
module.exports = {"hoursInput":"hoursInput--LaPTc","minsInput":"minsInput--2x6y1"};